<template>
  <v-card class="mt-4">
    <v-toolbar flat color="primary" dark class="justify-center">
      <v-toolbar-title>{{ value.title }}</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-row v-for="(field,index) in value.fields" :key="index">
        <Field @field_change="change" v-model="value.fields[index]"/>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" block @click="submit_changes">
        <v-progress-circular indeterminate v-if="loading"/>
        <span v-else>
                  ذخیره تنظیمات
        </span>
      </v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import Field from "./Field";
import {mapGetters} from "vuex";

export default {
  name: "Setting",
  components: {Field},
  props: {
    value: {
      type: Object,
    },
    loading: {
      type: Boolean,
    },
  },
  methods: {
    change(emit_value) {
      let new_object = emit_value.old_object

      if (emit_value.old_object.type === 1) {
        // Selection Changed
        new_object.selected = emit_value.new_value
      } else if (emit_value.old_object.type === 2) {
        // Tag Changed
        new_object.selected_tags = emit_value.new_value.selected_tags
      } else {
        // Comment Changed
        new_object.value = emit_value.new_value
      }
      this.$store.commit('change_field_value', {
        setting_id: this.value.id,
        field_id: emit_value.old_object.id,
        new_object: new_object
      })
    },
    submit_changes() {
      this.$store.dispatch('update_setting', {setting_id: this.value.id})
    }
  }
}
</script>

<style scoped>

</style>
